import Vue from 'vue';
import Vuex from 'vuex';

import { MODULE_USER } from './user-store';
import { CONFIGURE } from './configure';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        userModule: MODULE_USER,
        configure:CONFIGURE
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js